import "./style.min.css";

const Loader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[var(--body_background)]">
      <div className="relative flex flex-col items-center gap-6">
        {/* outer glow ring */}
        <div className="relative flex h-24 w-24 items-center justify-center">
          <div className="absolute inset-0 rounded-full border border-[var(--primary)]/20" />
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-[var(--primary)] border-r-[var(--accent)] animate-spin" />
          <div className="absolute inset-3 rounded-full border border-[var(--primary)]/15" />
          <div className="absolute inset-5 rounded-full bg-[var(--background_box)] shadow-[var(--box-shadow)]" />

          {/* center dot */}
          <div className="relative z-10 h-4 w-4 rounded-full bg-[var(--primary)] animate-pulse shadow-[0_0_20px_rgba(107,92,255,0.45)]" />
        </div>

        {/* text */}
        <div className="text-center">
          <p className="text-base font-semibold tracking-[0.2em] uppercase text-[var(--primary)]">
            Loading
          </p>
          <p className="mt-2 text-sm text-[var(--body_color)]">
            Chargement en cours...
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loader;
